import { HttpForm } from "./HttpForm";
import { axios } from "./Axios";
export class S3FileUpload extends HttpForm {
    id = 'file_upload';
    data = {
        uuid: null,
        key: null,
        bucket: null,
        file_name: null,
        content_type: null,
    };
    state = {
        loaded: false,
        uploading: false,
        uploadProgress: 0,
    };
    file = false;
    constructor() {
        super();
        this.resetUploadState();
    }
    upload(file) {
        const url = "/vapor/signed-storage-url";
        this.file = file;
        this.resetUploadState();
        return axios.post(url)
            .then(filesystem => this.uploadToS3(filesystem.data))
            .catch(e => this.setError(e));
    }
    uploadToS3(storage) {
        let self = this;
        self.state.uploading = true;
        if (self.file === null) {
            throw Error('Could not find file at selector ' + self.id);
        }
        const headers = {
            'Content-Type': storage.headers['Content-Type'],
            'x-amz.ecl': storage.headers['x-amz-acl'],
        };
        return axios.put(storage.url, self.file, {
            headers: headers,
            onUploadProgress: function (progressEvent) {
                if (progressEvent.total === undefined) {
                    progressEvent.total = 0;
                }
                self.state.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
        }).then(() => {
            self.data = {
                uuid: storage.uuid,
                key: storage.key,
                bucket: storage.bucket,
                file_name: self.file ? self.file.name : null,
                content_type: self.file ? self.file.type : null,
            };
        });
    }
    resetUploadState() {
        this.state = {
            loaded: false,
            uploading: false,
            uploadProgress: 0,
        };
    }
}
